import { render, staticRenderFns } from "./DocumentsToUploadCollection.vue?vue&type=template&id=8d770a02&"
import script from "./DocumentsToUploadCollection.vue?vue&type=script&lang=js&"
export * from "./DocumentsToUploadCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports